'use client';

import type { DehydratedState } from '@tanstack/react-query';
import type { PropsWithChildren } from 'react';
import { HydrationBoundary, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import React from 'react';
import { getQueryClient } from '@/core/services/query';

type ClientProvidersProps = PropsWithChildren<{
  dehydratedState?: DehydratedState;
}>;

export default function QueryClientProviders({
  children,
  dehydratedState,
}: ClientProvidersProps) {
  return (
    <QueryClientProvider client={getQueryClient()}>
      <HydrationBoundary state={dehydratedState}>{children}</HydrationBoundary>
      {process.env.NODE_ENV === 'development' && <ReactQueryDevtools />}
    </QueryClientProvider>
  );
}
